export enum SyncMeetingsSteps {
  linkExistingMeetings = 'link_existing_meetings',
  newOneOnOneMeetings = 'new_one_on_one_meetings',
  createNewTeammateWorkspaces = 'create_new_teammate_workspaces',
  createNewGroupWorkspaces = 'create_new_group_workspaces',
  inviteTeammates = 'invite_teammates',
}
